import { AddressType, AttachmentType, EntityType, PaymentScope, PaymentType, SupplierItem } from 'types/data';
import { ContextAction } from 'types/reducers';

// add here your custom actions
export enum StoreActions {
    SET_SUPPLIERS = 'storeActions/setSuppliers',
    SET_ADDRESS_TYPES = 'storeActions/setAddressTypes',
    SET_ENTITY_TYPES = 'storeActions/setEntityTypes',
    SET_ATTACHMENT_TYPES = 'storeActions/setAttachmentTypes',
    SET_PAYMENT_SCOPE = 'storeActions/setPaymentScope',
    SET_PAYMENT_TYPES = 'storeActions/setPaymentTypes',
}

// set your dispatch actions here
export const setSuppliers: ContextAction<SupplierItem[]> = (supplierItems: SupplierItem[]) => {
    return {
        type: StoreActions.SET_SUPPLIERS,
        payload: supplierItems,
    };
};

export const setAddressTypes: ContextAction<AddressType[]> = (data: AddressType[]) => {
    return {
        type: StoreActions.SET_ADDRESS_TYPES,
        payload: data,
    };
};

export const setEntityTypes: ContextAction<EntityType[]> = (data: EntityType[]) => {
    return {
        type: StoreActions.SET_ENTITY_TYPES,
        payload: data,
    };
};

export const setAttachmentTypes: ContextAction<AttachmentType[]> = (data: AttachmentType[]) => {
    return {
        type: StoreActions.SET_ATTACHMENT_TYPES,
        payload: data,
    };
};

export const setPaymentTypes: ContextAction<PaymentType[]> = (data: PaymentType[]) => {
    return {
        type: StoreActions.SET_PAYMENT_TYPES,
        payload: data,
    };
};

export const setPaymentScope: ContextAction<PaymentScope[]> = (data: PaymentScope[]) => {
    return {
        type: StoreActions.SET_PAYMENT_SCOPE,
        payload: data,
    };
};
